export enum ProductCode {
    Embed = "Embed",
    HQ = "HQ",
}
